// extracted by mini-css-extract-plugin
export default {"productGallery":"vG-z","inQuickShop":"wG-z"};